import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {OptionsModal} from '../OptionsModal';
import {Option} from './Option';
import {List} from './List';
import {TitleBlock} from './TitleBlock';
import {Title} from './Title';
import {Wrapper} from './Wrapper';
import {Technique} from '../Technique';

import './style.scss';

const SELECT_BUTTON_TEXT = 'Select techinque';
const TITLE = 'Select a technique';

/**
 * TechniquesOptionsModal:
 *  - Modal window for Techniques
 *  - It is used in the mobile
 */
export function TechniquesOptionsModal(props) {
  const [selectedOption, setSelectedOption] = useState(undefined);

  const onSelectOption = (optionID) => () => setSelectedOption(optionID);

  const isOptionSelected = (optionID) => optionID === selectedOption;

  const renderOption = (option) => {
    if (option.visible) {
      const className = isOptionSelected(option.id)
        ? 'techniqueOptionsModal_contentWrapper__list--item-selected'
        : '';
      return (
        <Option
          key={option.id}
          className={className}
          onClick={onSelectOption(option.id)}>
          <Technique
            title={option.title}
            image={option.image}
            description={option.description}
          />
        </Option>
      );
    } else return null;
  };

  const onSumbitSelection = () => {
    props.onAddStep({optionId: selectedOption});
  };

  const className = `${props.className} techniqueOptionsModal`;
  const optionSelectedClassName = `techniqueOptionsModal_contentWrapper ${
    selectedOption ? 'techniqueOptionsModal_contentWrapper--selected' : ''
  }`;
  return (
    <OptionsModal
      isOpen={props.isOpen}
      close={props.close}
      buttonText={SELECT_BUTTON_TEXT}
      isOptionSelected={!selectedOption}
      onSumbitSelection={onSumbitSelection}>
      <Wrapper className={className}>
        <TitleBlock className='techniqueOptionsModal_title'>
          <Title className='techniqueOptionsModal_title--title' title={TITLE} />
        </TitleBlock>
        <Wrapper className={optionSelectedClassName}>
          <List className='techniqueOptionsModal_contentWrapper__list'>
            {props.list.map(renderOption)}
          </List>
        </Wrapper>
      </Wrapper>
    </OptionsModal>
  );
}

TechniquesOptionsModal.propTypes = {
  /**
   * className of the techniqueOptionsModal
   */
  className: PropTypes.string,
  /**
   * List of options
   */
  list: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Uniqe id of the rectangle card
       */
      id: PropTypes.number,
      /**
       * Title of the rectangle card
       */
      title: PropTypes.string,
      /**
       * image to display in the rectangle card
       */
      image: PropTypes.string,
      /**
       * short description to display in the rectangle card
       */
      description: PropTypes.string,
      /**
       * Triggered on click of MoveIcon
       */
      onSelect: PropTypes.func,
    })
  ),
  /**
   * Boolean set/reset to open/close modal
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * to handle the open and close feature of modal window
   */
  close: PropTypes.bool,
  /**
   * function to invoke when adding step in mobile View
   */
  onAddStep: PropTypes.func,
};

TechniquesOptionsModal.defaultProps = {
  list: [],
  className: '',
};
